const ReportsPage = () => <h2>Reports</h2>;

export default ReportsPage;
